import { Component, OnInit } from '@angular/core';
import { BaseInputEditorDirective, InputEditor } from '../../../../base-input-editor.directive';
import { NbDialogRef, NbDialogService, NbMenuService } from '@nebular/theme';
import { SectionBuilderStoreService } from '../../../../sections-editor/shared-section-builder/section-builder-store.service';
import { ContentElement, ContentEnum, ContentStatusEnum, GridCellClass, GridLayoutEnum, ProductRowLayoutEnum, RowCell, Section } from '@urbannex/storethemes';
import { EditorTemplateService } from '../../../../editor-template.service';
import { PreviewEditStoreService } from '../../../../../services/preview-edit-store.service';
import { EditState } from '../../../../../model';
import { ProductEditorDialogComponent } from '../../../../dialogs/product-editor-dialog/product-editor-dialog.component';
import { OfbizFormsService } from '@urbannex/ofbiz-forms';
import { ConfigurationService } from '@urbannex/configuration';
import { Subject, combineLatest, takeUntil } from 'rxjs';


@Component({
  selector: 'ngx-product-list-input-dialog',
  templateUrl: './product-list-input-dialog.component.html',
  styleUrls: ['./product-list-input-dialog.component.scss']
})
export class ProductListInputDialogComponent extends BaseInputEditorDirective implements InputEditor,OnInit{
  rowCells:RowCell[];

  constructor(
    menuService:NbMenuService,
    sectionBuilderStoreService:SectionBuilderStoreService,
    ref: NbDialogRef<ProductListInputDialogComponent>,
    editorTemplateService:EditorTemplateService,
    private dialogService:NbDialogService,
    private previewEditStoreService:PreviewEditStoreService,
    private ofbizFormsService:OfbizFormsService,
    private configurationService:ConfigurationService){
    super(menuService,sectionBuilderStoreService,ref,editorTemplateService)
  }
  
  getLayoutClassValue(rawLayoutyClass){
    console.log(rawLayoutyClass)
    let layoutValue;
    if((rawLayoutyClass).includes(".")){
      let enumKey = rawLayoutyClass.split('.')[1] as keyof typeof ProductRowLayoutEnum;
      layoutValue = ProductRowLayoutEnum[enumKey];
    }else if(ProductRowLayoutEnum[layoutValue] != undefined){
      layoutValue = ProductRowLayoutEnum[layoutValue]
    }else{
      layoutValue = layoutValue;
    }
    return layoutValue;
  }
  
  setPlaceholderImages(section: Section): Section {
    let rowCells:RowCell[] = section.sectionData.rowOptions.rowCells;
    rowCells.forEach(rowCell => {
      console.log(rowCell.contentEnum);
      let cellCntEnum = this.getGridCellContentEnum(rowCell);
      console.log(cellCntEnum)
      switch (cellCntEnum) {
        case "Banner":
          /* const svgBackground = `data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22200%22 height=%22200%22%3E%3Crect width=%22200%22 height=%22200%22 fill=%22%23cccccc%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 font-size=%2220%22 text-anchor=%22middle%22 fill=%22%23777777%22 dy=%22.3em%22%3EPlaceholder%3C/text%3E%3C/svg%3E`;

          const svgBackground = `data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" width="200" height="200"%3E%3Crect width="200" height="200" fill="%23cccccc"/%3E%3Ctext x="50%25" y="50%25" font-size="20" text-anchor="middle" fill="%23777777" dy=".3em"%3EPlaceholder%3C/text%3E%3C/svg%3E`; */

          //let svgBackground = "data:image/svg+xml,%3Csvg xmlns=%22http://www.w3.org/2000/svg%22 width=%22200%22 height=%22200%22%3E%3Crect width=%22200%22 height=%22200%22 fill=%22%23cccccc%22/%3E%3Ctext x=%2250%25%22 y=%2250%25%22 font-size=%2220%22 text-anchor=%22middle%22 fill=%22%23777777%22 dy=%22.3em%22%3EPlaceholder%3C/text%3E%3C/svg%3E";
          //gridCell.imgSrc = gridCell.imgSrc;
          //svgBackground = this.sanitizer.bypassSecurityTrustStyle(`url("${svgBackground}")`);
          //gridCell.imgSrc = "data:image/svg+xml;utf8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2275%22%20height%3D%2250%22%20style%3D%22position%3Arelative%22%3E%3Ccircle%20cx%3D%2225%22%20cy%3D%2225%22%20r%3D%2225%22%20fill%3D%22red%22%20%2F%3E%3CforeignObject%20style%3D%22width%3A%20100%25%3B%20height%3A%20100%25%22%3E%3Chtml%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F1999%2Fxhtml%22%3E%3Cstyle%3E.x%20%7Bposition%3A%20absolute%3Bbackground%3A%20url(%22data%3Aimage%2Fsvg%2Bxml%3Butf8%2C%253Csvg%2520xmlns%253D'http%253A%252F%252Fwww.w3.org%252F2000%252Fsvg'%2520width%253D'100'%2520height%253D'50'%253E%253Ccircle%2520cx%253D'50'%2520cy%253D'25'%2520r%253D'25'%2520fill%253D'blue'%252F%253E%253C%252Fsvg%253E%22)%3B%20width%3A%20100%25%3B%20height%3A%20100%25%3B%7D%3C%2Fstyle%3E%3Cdiv%20class%3D%22x%22%3E%3C%2Fdiv%3E%3C%2Fhtml%3E%3C%2FforeignObject%3E%3C%2Fsvg%3E";
          rowCell.imgSrc = this.svgUrl;
          console.log(rowCells)
          break;
        case "Product Link":
          rowCell.imgSrc = this.svgUrl; //"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='200' height='200'%3E%3Crect width='200' height='200' fill='%23ccc'/%3E%3Ctext x='50%' y='50%' font-size='20' text-anchor='middle' fill='%23777' dy='.3em'%3EPlaceholder&nbsp;Banner Big%3C/text%3E%3C/svg%3E'";
        break;
      
        default:
          break;
      }               
    })
    return section
  }

  ngOnInit(): void {
    this.createSection(this.layoutClass);
    super.ngOnInit();
    //this.createSection(this.layoutClass)
  }
  
  createSection(layoutClass: string): void {
    console.log(layoutClass);
    let templateContentId;
    switch (layoutClass) {
      case "3":
        templateContentId = "ROW_1_CNT";
        //this.section.title = null;
        break;
      case "4":
        templateContentId = "ROW_4_CNT";
        //this.section.title = null;
        break;
      case "6":
        templateContentId = "ROW_6_CNT";
        //gridCells = this.createGridCells("grid-6");
        //this.section.title = null;
        break;
      default:
        templateContentId = "ROW_3_CNT";
        break;
    }
    this.editorTemplateService.getTemplate(templateContentId).subscribe(resp => {
      let section;
      let data = resp["data"];
      //Set the temporary ids
      section = this.setTemporaryIds(data["section"]);
      //Set the section Status;
      section.status = ContentStatusEnum.CTNT_IN_PROGRESS;
      //Set the status for each cell
      section = this.setCellContentStatus(section);
      //Set the placeholder images
      section = this.setPlaceholderImages(section) 
      //Create the menu;
      this.rowCells = section.sectionData.rowOptions.rowCells;
      console.log(section.sectionData.layoutClass);
      //Convert the layoutClass to its value
      section.sectionData.layoutClass = this.getLayoutClassValue(section.sectionData.layoutClass);
      //section.sectionData.layoutClass = GridLayoutEnum[section.sectionData.layoutClass];            
      this.section = section;
      this.selectedCell = this.rowCells[0]
      this.createMenu(this.rowCells);
      setTimeout(() => {
        this.hasLoaded = true;
        this.sectionBuilderStoreService.init(section)
      }, 100);
      
    })

  }
  
  setTemporaryIds(section: Section): Section {
    section.sectionId = "temp-section-"+this.generateUniqueId();
    let rowCells:RowCell[] = section.sectionData.rowOptions.rowCells;
    rowCells.forEach(rowCell => {
      rowCell.cellId = "temp-cell-"+this.generateUniqueId();
      let className:string = rowCell.className;
      rowCell.className = GridCellClass[className];
      let contentElements:ContentElement[] = rowCell.contentElements;
      contentElements.forEach(cntEl => {
        cntEl.elId = "temp-el-"+this.generateUniqueId();     
      })
    })
    return section
  }
  
  setCellContentStatus(section: Section): Section {
    let rowCells:RowCell[] = section.sectionData.rowOptions.rowCells;
    rowCells.forEach(rowCell => {
      rowCell.status = ContentStatusEnum.CTNT_IN_PROGRESS;
    })
    return section
  }
  
  onSave(e: any): void {
    //1. Change the statusses of the section and each cell to final draft
    this.section.status = ContentStatusEnum.CTNT_FINAL_DRAFT;
    this.section.sectionData.rowOptions.rowCells.forEach((cell:RowCell) => {
      cell.status = ContentStatusEnum.CTNT_FINAL_DRAFT;
    });
    this.previewEditStoreService.selectedPage$.subscribe(page => {
      console.log(page.pageName);
      if(this.section != undefined && this.section != null){
        page.sections.push(this.section);
        console.log(page.sections);
        this.previewEditStoreService.updateSelectedPage(page);
        this.previewEditStoreService.updatePageEditState(EditState.UPDATED);
        this.section = null;
      }
      //this.previewEditStoreService.updateEditState(EditState.EDITING);
      this.ref.close();
    })
    //2. Get the selected Page from the previewStore;
    //3. Add thgis section to the page;
    //4. Close the Input dialog
  }
  /**
   * Opens a product selection or creating dialog
   * @param mode Two options: "new" and "existing"
   * New mode consists of forms to create a new product
   * Existing consists of a liost of existing product to choose from
   */
  productDialog(mode:string){
    // ProductEditorDialogComponent
    "Opening productDialog - section"
    this.dialogService.open(ProductEditorDialogComponent, {
      closeOnBackdropClick:false,
      context:{
        mode:mode,
        title:"Adding Product Cell",
        standAlone:true
      }
    }).onClose.subscribe(resp => {
      const formData = resp["data"]["formData"];
      let link = formData["link"];
      const formName = formData["formName"];
      const formLocation = formData["formLocation"];
      const parts = link.split('/');
      const productId = parts[parts.length - 1]
      console.log(productId);
      combineLatest([
        this.ofbizFormsService.getValue(formData,{productId:productId},null),
        this.ofbizFormsService.getValue({formName:"ProductSummary",formLocation:"component://kwikstore/widget/ProductForms.xml"},{productId:productId},null)
      ]).pipe(
        takeUntil(this.destroy$)
      )
      .subscribe(([fieldsData,summaryData]:[any,any]) => {
        const formData = fieldsData["data"]["formData"];
        const fields = formData["fields"];
        //this.populateContentElements(fields);
        const summary = summaryData["data"]["formData"]
        //this.populateContentElements(summary["fields"]);
      })
      /* this.ofbizFormsService.getValue(formData,{productId:productId},null)
      .subscribe(resp => {
        const formData = resp["data"]["formData"];
        const fields = formData["fields"];
        this.populateContentElements(fields);
      }) */
    })
  }
  /**
   * Add a product cell to the existing section using the last cells as a template
   */
  addProductCell(){
    //console.log(this.section);
    let rowCells:RowCell[] = this.section.sectionData.rowOptions.rowCells;
    let lastCell = rowCells[rowCells.length - 1];
    const newCell:RowCell = {
      ...lastCell,
      cellId:"temp-cell-"+this.generateUniqueId(),
      status:ContentStatusEnum.CTNT_IN_PROGRESS
    }
    rowCells.push(newCell);
    this.section.sectionData.rowOptions.rowCells = rowCells;
    this.sectionBuilderStoreService.updateSection(this.section);
  }



}
